
export class PrescriptionPageDatabase {
  constructor() {
  }

  public salamatApiToken?: string;
  public citizenToken?: string;

  public taminApiToken?: string;

  public citizenNationalCode?: string;
}
